export interface SimplePaginatorAriaLabels {
  previous: string;
  next: string;
  indicator: string;
}

export interface SimplePaginator {
  total: number;
  current: number;
  label: string;
  ariaLabels: SimplePaginatorAriaLabels;
}
